import BaseSchema from "./base";

class Analysis extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "analysis";
  static fields = [
    "uuid",
    "code",
    "name",
    "quantizationLimit",
    "indicativeUncertainty",
    "parameters",
    "catalogReference",
    "support",
    "supportList",
    "isDefault",
  ];

  static relatedFields = {
    parameters: {
      m2m: true,
      owner: true,
      relatedKey: "parameters",
      tableName: "parameters",
    },
  };

  static dateFields = [];
}

export default Analysis;
